<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "locale-select-sheet" },
    [
      _c(
        "b-dropdown",
        {
          staticClass: "dropdown-language lang-drop",
          attrs: { id: "dropdown-grouped", variant: "link", right: "" },
          scopedSlots: _vm._u([
            {
              key: "button-content",
              fn: function () {
                return [
                  _c("span", { staticClass: "d-flex align-items-center" }, [
                    _c("span", { staticClass: "ml-50 text-body" }, [
                      _vm._v(
                        _vm._s(
                          _vm.currentLocale.locale.slice(0, 2).toUpperCase()
                        )
                      ),
                    ]),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        _vm._l(_vm.locales, function (localeObj) {
          return _c(
            "b-dropdown-item",
            {
              key: localeObj.locale,
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.changeLocale(localeObj.locale)
                },
              },
            },
            [
              _c("span", { staticClass: "ml-50" }, [
                _vm._v(_vm._s(localeObj.name)),
              ]),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/Locale.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default ({
  render,
  staticRenderFns,
  components: {
    BDropdown: bootstrapvue["BDropdown"],
    BDropdownItem: bootstrapvue["BDropdownItem"],
    BImg: bootstrapvue["BImg"]
  },
  // ! Need to move this computed property to comp function once we get to Vue 3
  computed: {
    currentLocale() {
      return this.locales.find(l => l.locale === this.$i18n.locale);
    }
  },
  methods: {
    changeLocale(newLocale) {
      // save locale to local storage
      localStorage.setItem("appLocale", newLocale);
      this.updateQueryParameters(newLocale);
    },
    updateQueryParameters(newLocale) {
      const currentPath = window.location.pathname;
      const languageCodeRegex1 = new RegExp(`^/${newLocale}(\/|$)`);
      const isLanguageAvailable = languageCodeRegex1.test(currentPath);
      if (!isLanguageAvailable) {
        const languageCodeRegex = /^\/[a-zA-Z]{2}(\/|$)/;
        const hasLanguageCode = languageCodeRegex.test(currentPath);
        let newPath;
        if (hasLanguageCode) {
          newPath = currentPath.replace(languageCodeRegex, `/${newLocale}/`);
        } else if (currentPath === "/") {
          newPath = `/${newLocale}`;
        } else {
          newPath = `/${newLocale}${currentPath}`;
        }
        window.history.pushState({}, "", newPath);
        window.location.reload();
      }
    }
  },
  data() {
    return {
      locales: [{
        locale: "en",
        img: require("@/assets/images/flags/en.png"),
        name: "English"
      }]
    };
  }
});

//# sourceURL=webpack:///./src/layouts/components/Locale.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.img-fluid1 {
  visibility: visible;
  opacity: 1;
  bottom: 15px;
  z-index: 996;
  width: 30px;
  height: 30px;
  transition: all 0.4s;
}[dir] .img-fluid1 {
  background: #7268ef;
  border-radius: 50px;
}[dir=ltr] .img-fluid1 {
  right: 15px;
}[dir=rtl] .img-fluid1 {
  left: 15px;
}
[dir=ltr] .margin-30px {
  margin-left: 30px;
}
[dir=rtl] .margin-30px {
  margin-right: 30px;
}
.img-fluid12 {
  object-fit: cover;
  /* Maintain the image aspect ratio and cover the container */
  width: 30px;
  height: 30px;
}
[dir] .img-fluid12 {
  border-radius: 20px;
}
.lang-drop .dropdown-toggle {
  display: flex !important;
  align-items: center;
  width: 50px;
}[dir] .lang-drop .dropdown-toggle {
  padding: 0 !important;
}
[dir] .lang-drop .dropdown-toggle::after {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236e6b7b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E") !important;
}
</style>
